import getConfig from 'next/config';

const env = getConfig() ? getConfig().publicRuntimeConfig : process.env;
export default env;
